//Klepsch Seufert 2020
export const cognitiveLoadItems = [
  {
    id: 'icl_1',
    text: {
      de: '"Bei dieser Aufgabe musste man viele Dinge gleichzeitig im Kopf bearbeiten."',
      en: 'For this task, many things needed to be kept in mind simultaneously.'
    }
  },
  {
    id: 'icl_2',
    text: {
      de: '"Diese Aufgabe war sehr komplex."',
      en: 'This ask was very complex.'
    }
  },
  {
    id: 'gcl_1',
    text: {
      de: '"Ich habe mich angestrengt, mir nicht nur einzelne Dinge zu merken, sondern auch den Gesamtzusammenhang zu verstehen."',
      en: 'I made an effort, not only to understand several details, but to understand the overall context.'
    }
  },
  {
    id: 'gcl_2',
    text: {
      de: '"Es ging mir beim Bearbeiten der Lerneinheit darum, alles richtig zu verstehen."',
      en: 'My point while dealing with the task was to understand everything correct.'
    }
  },
/*  {
    id: 'gcl_3',
    text: {
      de: '"Die Lerneinheit enthielt Elemente, die mich unterstützten, den Lernstoff besser zu verstehen."',
      en: 'The learning task consisted of elements supporting my comprehension of the task.'
    }
  },*/
  {
    id: 'ecl_1',
    text: {
      de: '"Bei dieser Aufgabe ist es mühsam, die wichtigsten Informationen zu erkennen."',
      en: 'During the task, it was exhausting to find the important information.'
    }
  },
  {
    id: 'ecl_2',
    text: {
      de: '"Die Darstellung dieser Aufgabe ist ungünstig, um wirklich etwas zu lernen."',
      en: 'The design of the task was very inconvenient for learning.'
    }
  },
  {
    id: 'ecl_3',
    text: {
      de: '"Bei dieser Aufgabe ist es schwer, die zentralen Inhalte miteinander in Verbindung zu bringen."',
      en: 'During the task, it was difficult to recognize and link the crucial information.'
    }
  },

]

export const paasItem = [
  {
    id: 'cognitive load',
    text: {
      de: 'Wie stark haben Sie sich bei den letzten vier Beispielen angestrengt, um sie zu verstehen?',
      en: 'How much effort did you invest to understand the last four worked examples?'
    }
  }
]